import { t } from 'ember-intl'
import UiButton from 'teacher-ui-client/components/ui-button'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { on } from '@ember/modifier'
import Component from '@glimmer/component'
import { classesForTheme } from 'teacher-ui-client/components/copy-classes/themes'
import { subscriptionTypeToThemeKey } from 'teacher-ui-client/utils/themes'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { PanelHeadingIcon } from 'teacher-ui-client/components/base/panel-heading-icon'

interface Signature {
  Element: HTMLElement
  Args: {
    fromSubscriptionType?: SubscriptionType
    toSubscriptionType: SubscriptionType
    classCount: number
    studentCount: number
    submitButtonEnabled: boolean
    onSubmit: () => void
  }
}

export class SummaryPanel extends Component<Signature> {
  get themeKey() {
    return subscriptionTypeToThemeKey(this.args.toSubscriptionType)
  }

  get themeClasses() {
    return classesForTheme(this.themeKey)
  }

  <template>
    <section class="rounded-md border shadow-md" ...attributes>
      <div class="rounded-t-md px-4 py-3 {{this.themeClasses.background.mid}}">
        <h3 class="flex items-center gap-3">
          <PanelHeadingIcon @icon="phosphor-paperclip-bold" @iconColorClass={{this.themeClasses.text}} />
          <span>{{t "components.copyClasses.summary.heading"}}</span>
        </h3>
      </div>
      <div class="space-y-6 p-8">
        <div>
          <h4 class="mb-1 {{this.themeClasses.text}}">{{t "components.copyClasses.summary.copyingFrom"}}</h4>
          {{#if @fromSubscriptionType}}
            <span>{{t @fromSubscriptionType}}</span>
          {{else}}
            <span class="text-dusty-black-200 italic">{{t "components.copyClasses.summary.noProgramSelected"}}</span>
          {{/if}}
        </div>
        <div>
          <h4 class="mb-1 {{this.themeClasses.text}}">{{t "components.copyClasses.summary.copyingTo"}}</h4>
          <span>{{t @toSubscriptionType}}</span>
        </div>
        <hr />
        <div>
          <h4 class="mb-1 {{this.themeClasses.text}}">{{t "components.copyClasses.summary.classes"}}</h4>
          {{#if @classCount}}
            <span class="font-bold">{{@classCount}}</span>
          {{else}}
            <span class="text-dusty-black-200 italic">{{t "components.copyClasses.summary.noClassesSelected"}}</span>
          {{/if}}
        </div>
        <div>
          <h4 class="mb-1 {{this.themeClasses.text}}">{{t "components.copyClasses.summary.numOfStudents"}}</h4>
          {{#if @studentCount}}
            <span class="font-bold">{{@studentCount}}</span>
          {{else}}
            <span class="text-dusty-black-200 italic">{{@studentCount}}</span>
          {{/if}}
        </div>
        <UiButton
          data-test-submit-copy-classes
          @appearance={{ButtonAppearance.regular}}
          @disabled={{if @submitButtonEnabled false true}}
          class="px-6 whitespace-nowrap"
          {{on "click" @onSubmit}}
        >{{t "components.copyClasses.summary.submit"}}</UiButton>
      </div>
    </section>
  </template>
}
